'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var POPUP_OPEN = exports.POPUP_OPEN = 'POPUP_OPEN';
var POPUP_CLOSE = exports.POPUP_CLOSE = 'POPUP_CLOSE';
var POPUP_TOGGLE = exports.POPUP_TOGGLE = 'POPUP_TOGGLE';

var ARROW_DIR = exports.ARROW_DIR = {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/popupConstants.js
// module id = 140
// module chunks = 0